// Lao labels for the hotel-first product: sidebar areas, product modules and add-on states.
export const laoProduct: Record<string, string> = {
  'Hotel property': 'ທີ່ພັກໂຮງແຮມ',
  Billing: 'ການເກັບເງິນ',
  'Online booking': 'ການຈອງອອນລາຍ',
  'Hotel reports': 'ລາຍງານໂຮງແຮມ',
  'Finance overview': 'ພາບລວມການເງິນ',
  Sales: 'ການຂາຍ',
  'Assets & treasury': 'ຊັບສິນ ແລະ ຄັງເງິນ',
  'Accounting & finance': 'ບັນຊີ ແລະ ການເງິນ',
  'Inventory & production': 'ສາງສິນຄ້າ ແລະ ການຜະລິດ',
  'Mobile API': 'Mobile API',
  Core: 'ລະບົບຫຼັກ',
  Connections: 'ການເຊື່ອມຕໍ່',
  'Front desk, room calendar, reservations, housekeeping, rates, online booking, guest messaging and folio billing.':
    'ຝ່າຍຕ້ອນຮັບ, ປະຕິທິນຫ້ອງ, ການຈອງ, ແມ່ບ້ານ, ລາຄາ, ການຈອງອອນລາຍ, ຂໍ້ຄວາມແຂກ ແລະ ການເກັບເງິນຕາມໂຟລິໂອ.',
  'General ledger, purchases and expenses, quotations and point of sale, period close, financial statements and tax reports.':
    'ບັນຊີແຍກປະເພດ, ການຊື້ ແລະ ລາຍຈ່າຍ, ໃບສະເໜີລາຄາ ແລະ ຂາຍໜ້າຮ້ານ, ການປິດງວດ, ງົບການເງິນ ແລະ ລາຍງານອາກອນ.',
  'Products, warehouses, stock movements and production.':
    'ສິນຄ້າ, ສາງ, ການເຄື່ອນໄຫວສິນຄ້າ ແລະ ການຜະລິດ.',
  'Employees, salary runs, benefits and configurable tax brackets.':
    'ພະນັກງານ, ການຈ່າຍເງິນເດືອນ, ສະຫວັດດີການ ແລະ ຂັ້ນອາກອນທີ່ຕັ້ງຄ່າໄດ້.',
  'Money transfers between accounts and fixed asset registers with depreciation.':
    'ການໂອນເງິນລະຫວ່າງບັນຊີ ແລະ ທະບຽນຊັບສິນຄົງທີ່ພ້ອມຄ່າຫຼຸ້ຍຫ້ຽນ.',
  'Scoped API access for Flutter and other authorized clients.':
    'ການເຂົ້າເຖິງ API ຕາມຂອບເຂດ ສຳລັບ Flutter ແລະ ແອັບທີ່ໄດ້ຮັບອະນຸຍາດ.',
  'Hotel PMS is included with every property. Add modules as it grows.':
    'ທຸກທີ່ພັກມີລະບົບຈັດການໂຮງແຮມ. ເພີ່ມໂມດູນຕາມການເຕີບໂຕ.',
  'Always included': 'ມີໃຫ້ສະເໝີ',
  Included: 'ລວມຢູ່ແລ້ວ',
  Requires: 'ຕ້ອງເປີດ',
  'Used by': 'ໃຊ້ໂດຍ',
  enabled: 'ເປີດແລ້ວ',
  disabled: 'ປິດແລ້ວ',
  'Disabling an add-on retains its records. Hotel folios keep posting invoices and receipts to the ledger, so enabling Accounting later shows complete books. Disabling Mobile API revokes the workspace’s existing API keys.':
    'ປິດສ່ວນເສີມແລ້ວຍັງເກັບຂໍ້ມູນໄວ້. ໂຟລິໂອໂຮງແຮມຍັງບັນທຶກໃບແຈ້ງໜີ້ ແລະ ໃບຮັບເງິນເຂົ້າບັນຊີ, ເມື່ອເປີດບັນຊີພາຍຫຼັງຈຶ່ງເຫັນບັນຊີຄົບຖ້ວນ. ການປິດ Mobile API ຈະຖອນກະແຈ API ທີ່ມີຢູ່.',
  'This add-on is off for this property. Turn it on in Control Center → Add-ons.':
    'ສ່ວນເສີມນີ້ປິດຢູ່ສຳລັບທີ່ພັກນີ້. ເປີດໄດ້ທີ່ ສູນຄວບຄຸມ → ສ່ວນເສີມ.',
  'This add-on is off for this property. Ask your LFB administrator to turn it on.':
    'ສ່ວນເສີມນີ້ປິດຢູ່ສຳລັບທີ່ພັກນີ້. ກະລຸນາຂໍໃຫ້ຜູ້ດູແລລະບົບ LFB ເປີດໃຫ້.',
  'Open Control Center': 'ເປີດສູນຄວບຄຸມ',
  'Enable Accounting & finance in Control Center → Add-ons to use this module.':
    'ເປີດ ບັນຊີ ແລະ ການເງິນ ທີ່ ສູນຄວບຄຸມ → ສ່ວນເສີມ ເພື່ອໃຊ້ໂມດູນນີ້.',
  'Enable Inventory & production in Control Center → Add-ons to use this module.':
    'ເປີດ ສາງສິນຄ້າ ແລະ ການຜະລິດ ທີ່ ສູນຄວບຄຸມ → ສ່ວນເສີມ ເພື່ອໃຊ້ໂມດູນນີ້.',
  'Enable People & payroll in Control Center → Add-ons to use this module.':
    'ເປີດ ພະນັກງານ ແລະ ເງິນເດືອນ ທີ່ ສູນຄວບຄຸມ → ສ່ວນເສີມ ເພື່ອໃຊ້ໂມດູນນີ້.',
  'Enable Assets & treasury in Control Center → Add-ons to use this module.':
    'ເປີດ ຊັບສິນ ແລະ ຄັງເງິນ ທີ່ ສູນຄວບຄຸມ → ສ່ວນເສີມ ເພື່ອໃຊ້ໂມດູນນີ້.',
};
